<template>
  <div></div>
</template>
<script>
import { mapState } from 'vuex'
import { getCity } from '@/services/city.js'
import { getLinks } from '@/utils/linkUtil'
import tujiaRedirect from '@/utils/tujiaRedirect.js'

export default {
  components: {},
  mixins: [tujiaRedirect],
  props: {
    compProps: {
      type: Object,
      default: function() {
        return {}
      }
    },
    payLoad: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  data() {
    return {}
  },
  computed: {
    ...mapState(['houseFilter'])
  },
  watch: {
    payLoad(newVal) {
      if (newVal && newVal.type === 'jumpPage') {
        this.jumpPage(newVal.data)
      }
    }
  },
  mounted() {
    if (this.compProps?.mate?.privateProps?.cityChoice === 'allCity') {
      this.initCity()
    }
  },
  methods: {
    /**
     * 初始化文章信息
     */
    async initCity() {
      try {
        let allCityConfig = {
          cityList: [],
          hotCityList: [],
          fixedIndexList: []
        }
        const ret = await getCity()
        if (ret) {
          const data = ret?.data || {}
          allCityConfig.cityList = data?.cityGroup?.cities || []
          allCityConfig.hotCityList = data?.cityGroup?.hotCities || []
          allCityConfig.cityList.forEach((item, index) => {
            allCityConfig.fixedIndexList.push({ indexText: item.group, selected: false })
            item?.cities?.length && item.cities.forEach((cityItem) => {
              if (String(cityItem.cityId) === String(this.cityId)) {
                this.cityText = cityItem.cityName || ''
              }
            })
          })
        }
        this.$emit('init', { allCityConfig })
      } catch (e) {
        this.$toast('获取城市列表失败，请稍后重试')
      }
    },
    // 跳转L页
    jumpPage(data) {
      const cityItem = data?.cityItem || {}
      const { code = `cms_${this.$root.promotionId}` } = this.$route.query
      setTimeout(() => {
        const links = getLinks('list', {
          cityId: cityItem.cityId,
          pinYin: cityItem.pinYin,
          checkInDate: this.houseFilter.checkInDate,
          checkOutDate: this.houseFilter.checkOutDate,
          channelId: code
        })
        this.doRedirect({
          mpLink: links.mpUrl,
          appLink: links.tAppUrl,
          cAppLink: links.cAPPUrl,
          activeLink: links.webUrl
        })
      }, 300)
    }
  }
}
</script>
